import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import parse from "html-react-parser";
import styled from "styled-components";
const SingleMicStartilotPopup = ({
  transcriptChat,
  setTranscriptChat,
  storedTranscript,
}) => {
  const conversation = [
    { username: "new", createdAt: "2025-05-15T08:57:57.591Z", response: "hi" },
    {
      username: "new chat",
      createdAt: "2025-05-15T09:57:57.591Z",
      response: "hello",
    },
  ];

  console.log(storedTranscript, "storedTranscript");

  const handleSignupConfirm = () => {
    setTranscriptChat(!transcriptChat);
  };
  return (
    <>
      <ModalCstm
        size="sm"
        centered
        show={transcriptChat}
        onHide={handleSignupConfirm}
      >
        <Modal.Body className="p-0">
          <div
            style={{
              bottom: 10,
              right: 10,
              zIndex: 999999,
              left: 10,
            }}
          >
            {
              <>
                <div style={{ borderRadius: 20 }}>
                  <div
                    className="top d-flex align-items-center justify-content-center p-3 position-relative"
                    style={{
                      background: "#216fc8",
                      borderTopLeftRadius: 20,
                      borderTopRightRadius: 20,
                    }}
                  >
                    <div
                      className="content text-center py-2"
                      style={{ fontFamily: "Aharoni" }}
                    >
                      <h2
                        className="m-0 fw-bold text-white"
                        style={{ fontSize: 50, lineHeight: "40px" }}
                      >
                        Message
                      </h2>
                      {/* <h5 className="m-0 text-white">Concierge</h5> */}
                    </div>
                  </div>
                  <div className="p-3" style={{ fontSize: 12 }}>
                    <div
                      className="ans-block overflow-auto border-0"
                      style={{ height: "calc(-310px + 100vh)" }}
                    >
                      {storedTranscript?.length == 0 && (
                        <div className="h-100 d-flex align-items-center justify-content-center text-center">
                          <p className="m-0 fw-bold">No message</p>
                        </div>
                      )}

                      <div className="textmessageWrpper ">
                        <div className="ans-sub-block border-0">
                          {storedTranscript.map((entry, index) => (
                            <div key={index}>
                              <div className="bg-[#040404] rounded-lg  mb-2 overflow-auto subblock d-flex align-items-start gap-10">
                                <div className="aiicon">
                                  <img
                                    src="/assets/images/logo.png"
                                    alt="profile"
                                    className="profile object-fit-contain"
                                    style={{ height: 50, width: 50 }}
                                  />
                                </div>
                                <div
                                  className="w-100"
                                  style={{ maxWidth: "calc(100% - 45px)" }}
                                >
                                  <p className="mb-2 font_16 text-blue font_600">
                                    {/* <span>{parse(entry?.username)}</span> */}
                                    <span>User</span>
                                    <span className="ms-2 d-inline-block text-gray-500 font_400">
                                      ({new Date(entry?.time).toUTCString()})
                                    </span>
                                  </p>
                                  <div className="d-flex justify-content-between gap-10">
                                    <div
                                      className="left"
                                      style={{ maxWidth: 700 }}
                                    >
                                      <pre className="mb-2 text-justify white-space-pre">
                                        {parse(entry?.transcript)}
                                      </pre>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
          </div>
        </Modal.Body>
      </ModalCstm>
    </>
  );
};
const ModalCstm = styled(Modal)`
  .modal-dialog {
    max-width: 500px;
    margin-right: 0;
    padding-right: 10px;
    .modal-content {
      border-radius: 25px;
    }
  }
`;

export default SingleMicStartilotPopup;
